<template>
  <div class="col-lg-4 col-sm-6 col-md-6">
    <div class="conserve_activities_box_item conserve_blog_list">
      <figure>
        <a :href="item.url">
          <img
            :src="getImgUrl(item.banner_image)"
            class="img-fluid"
            alt="event"
          />
          <figcaption>
            <div class="px-2 my-3">
              <h5>{{ item.title }}</h5>
            </div>
            <div class="user">
              <i class="las la-user-circle"></i> Posted by:
              <span>{{ item.user }}</span>
            </div>
            <div class="points_info">
              <i class="las la-star"></i> Points: {{ item.points }}
            </div>
            <div class="points_info">
              <i class="las la-border-all"></i> Category: {{ item.category }}
            </div>
          </figcaption>
        </a>
      </figure>
    </div>
  </div>
</template>
<script>
export default {
  name: "blog-card",
  props: ["item"],
  methods: {
    getImgUrl(filename) {
      if (filename) {
        return filename;
      } else {
        return defult_image;
      }
    },
  },
};
</script>
